import { W as WuiSelectInput$1, d as defineCustomElement$1 } from './p-C7ruMG4C.js';

const WuiSelectInput = WuiSelectInput$1;
const defineCustomElement = defineCustomElement$1;

export { WuiSelectInput, defineCustomElement };
